//@flow
import * as React from 'react';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import withStateHandlers from 'recompose/withStateHandlers';
import addressListFactory from 'common/components/common/AddressList';
import GroupedLocationCardContainer from 'common/entity/locationMaster/GroupedLocationCardContainer';
const GroupedAddressListComponent = addressListFactory({});

const recomputeRowHeights = {
    UNSAFE_componentWillReceiveProps(nextProps) {
        const {
            groupedLocations,
            expandedGroupId,
            addressListRef,
            expandedLocationId
        } = this.props;
        const {
            groupedLocations: nextGroupedLocations,
            expandedGroupId: nextExpandedGroupId,
            expandedLocationId: nextExpandedLocationId
        } = nextProps;

        if (
            expandedGroupId !== nextExpandedGroupId ||
            expandedLocationId !== nextExpandedLocationId ||
            groupedLocations !== nextGroupedLocations
        ) {
            if (addressListRef) {
                addressListRef.recomputeRowHeights();
            }
        }
    }
};
export default compose(
    withStateHandlers(
        {
            addressListRef: null,
            scrollToAlignment: 'start'
        },
        {
            setAddressListRef: () => addressListRef => {
                return { addressListRef };
            }
        }
    ),
    withHandlers({
        getCardHeight: ({
            locations: groupedLocations,
            expandedGroupId,
            expandedLocationId
        }) => ({ index }) => {
            const baseHeight = 60;
            let height = baseHeight;
            const groupedLocation = groupedLocations.get(index);

            const groupedLocationsSize = groupedLocation.locations.size;
            const isExpanded = expandedGroupId === groupedLocation.groupId;
            if (groupedLocationsSize > 0 && isExpanded) {
                height = height + groupedLocationsSize * 85;
                groupedLocation.locations.forEach(location => {
                    const { address, id } = location;
                    if (address && address.getFilteredFullAddress()) {
                        height = height + 28;
                    }
                    if (expandedLocationId === id) {
                        height = height + 68;
                    }
                });
            }
            return height;
        },
        getAddressListRef: ({ setAddressListRef }) => ref => {
            setAddressListRef(ref);
        },
        getAddressCardByIndex: ({
            locations: groupedLocations,
            handleGroupVerify,
            handleGroupCardClick,
            expandedGroupId,
            handleAddressChange,
            handleVerify,
            handleCardClick,
            expandedLocationId,
            selectedLocationId,
            handleResetSingleLocation,
            handleResetGroupLocations,
            handleLatLngClick,
            getRadiusAndCenter
        }) => ({ key, index, style }) => {
            const groupedLocation = groupedLocations.get(index);
            return (
                <GroupedLocationCardContainer
                    expandedLocationId={expandedLocationId}
                    selectedLocationId={selectedLocationId}
                    groupedLocation={groupedLocation}
                    handleAddressChange={handleAddressChange}
                    handleVerify={handleVerify}
                    handleCardClick={handleCardClick}
                    handleGroupVerify={handleGroupVerify}
                    handleGroupCardClick={handleGroupCardClick}
                    key={key}
                    index={index}
                    style={style}
                    isSelected={expandedGroupId === groupedLocation.groupId}
                    isExpanded={expandedGroupId === groupedLocation.groupId}
                    handleResetSingleLocation={handleResetSingleLocation}
                    handleResetGroupLocations={handleResetGroupLocations}
                    handleLatLngClick={handleLatLngClick}
                    getRadiusAndCenter={getRadiusAndCenter}
                />
            );
        }
    }),
    lifecycle(recomputeRowHeights)
)(GroupedAddressListComponent);
